export enum CategoryId {
  All = 'all',
  Text = 'text',
  Image = 'image',
  Gallery = 'gallery',
  Button = 'button',
  Box = 'box',
  Container = 'container',
  Embeds = 'embeds',
  Decorative = 'decorative',
  Navigation = 'navigation',
  Media = 'media',
  Strip = 'strip',
  Shape = 'shape',
  VectorShape = 'vectorShape',
  VectorArt = 'vectorArt',
  Video = 'video',
  Music = 'music',
  Social = 'social',
  Contact = 'contact',
  List = 'list',
  Blog = 'blog',
  NewBlog = 'newBlog',
  NewBlogWelcome = 'newBlogWelcome',
  Bookings = 'bookings',
  BookingsWelcome = 'bookingsWelcome',
  Store = 'store',
  StoreWelcome = 'storeWelcome',
  Community = 'community',
  Members = 'members',
  MembersWelcome = 'membersWelcome',
  Events = 'events',
  EventsWelcome = 'eventsWelcome',
  Other = 'other',
  Page = 'page',
  Interactive = 'boxSlideShow',
  Developer = 'developer',
  Repeater = 'repeater',
  Database = 'database',
  MyWidgets = 'installedWidgets',
  DatabaseWelcome = 'databaseWelcome',
  InstalledApps = 'installedApps',
  SavedComponents = 'savedComponents',
  SavedComponentsWelcome = 'savedComponentsWelcome',
  MobileEmbeds = 'mobileEmbeds',
  MobileSocial = 'mobileSocial',
  MobileBox = 'mobileBox',
  MobileButton = 'mobileButton',
  MobileText = 'mobileText',
}
